module.exports = __webpack_public_path__ + "img/pg.6919b3b4.png";